import React from 'react';
import Header from './Header';

const Page = ({ category, title, actions, children }) => (
  <div className="m-2 md:m-8 mt-4 pb-6">
    <div className="flex justify-between items-end gap-3 flex-wrap mb-4">
      <Header category={category} title={title} />
      {actions ? <div className="flex gap-2 flex-wrap items-center">{actions}</div> : null}
    </div>
    {children}
  </div>
);

export default Page;
